import { makeStyles, AccordionSummary, AccordionActions, AccordionDetails } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles'
import { theme } from '../../styles/setTheme'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    headerTitle: {
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        // fontFamily: '"Helvetica", "Arial", sans-serif !important',
    },
    heading: {
        fontSize: theme.typography.pxToRem(17),
        fontWeight: theme.typography.fontWeightRegular,
        // fontFamily: 'HelveticaBold'
    },
    icon: {
        color: "#ffffff",
    },
    iconExpander: {
        color: "#000",
    },
    detalle: {
        padding: "25px 10px 20px",
    },
    classOne: {
        textTransform: 'lowercase',
        '& > :first-letter': {
            textTransform: 'uppercase'
        }
    },
    wrapper: {
        position: 'relative',
    },
    fieldProgress: {
        color: theme.palette.secondary.primary,
        position: 'absolute',
        top: '50%',
        left: '80%',
        marginTop: -6,
        marginLeft: -12,
    },
    autocompleteProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -6,
        marginLeft: -12,
    },
    form: {
        width: '100%',
        marginBottom: 0,
        marginTop: '12px',
    },
    largeAvatarBrowser: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.avatar,
    },
    largeAvatarMobile: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.avatar,
    },
    textBrowser: {
        fontSize: '14px',
    },
    textMobile: {
        fontSize: '12px',
    },
    pregDesc: {
        fontWeight: 'bold',
        fontSize: '16px',
    },

    //Agregado
    inputStyle: {
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        /*"& .MuiInputBase-input:focus" :{
            borderBottom: '2px solid #4285f4 !important',
        },*/
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        '& label': {
            // fontFamily: 'HelveticaBold',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },
        '& error': {
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root.Mui-error":{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root":{
            // fontFamily: 'HelveticaBold',
        }

        /*"& .MuiInput-underline:after":{
            BorderBottom: '2px solid #4285f4',
        }*/
        //borderBottom: '1px solid #4285f4 !important',
    },

    selectStyle: {
        // fontFamily: 'HelveticaBold',
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },

        "& .MuiFormHelperText-root.Mui-error": {
            // fontFamily: 'HelveticaBold',
        },
    },

    radioStyle: {
        // fontFamily: 'HelveticaBold',
        "& .MuiTypography-body1" :{
            // fontFamily: 'HelveticaBold',
        }
    },

    buttonStyle : {
        // fontFamily: 'HelveticaBold',
        
    }


}));



export const StyledAccordionDetails = withStyles({
    root: {
        padding: "20px 16px 16px",
    }
})(AccordionDetails);



export const StyledAccordionSummary = withStyles({
    root: {
        // backgroundColor: theme.palette.primary.main,
        backgroundColor: "#ddd",
        borderBottom: "1px solid #A8A8A8",
        //color: "#ffffff",
        marginBottom: -1,
        minHeight: 30,
        fontSize: 15,
        fontWeight: 500,
        color: "#000000",
        // fontFamily: "HelveticaBold",
       // boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        '&$expanded': {
            minHeight: 30,
        },
    },
    content: {
        '&$expanded': {
            margin: '0px 0',
        },
    },
    expanded: {},
})(AccordionSummary);


export const AccordionEstSummary = withStyles({
    root: {
    backgroundColor: '#eee',
    borderBottom: '1px solid #ddd',
    marginBottom: -1,
    minHeight: 46,
    '&$expanded': {
        minHeight: 46,
    },
    // fontFamily: "HelveticaBold",
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

export const StyledAccordionActions = withStyles({
    root: {
        padding: '8px 25px',
    },
})(AccordionActions);
